import type { HeadingProps } from '@pearlconvert/ui/components/typography/heading.types'

export default function Heading({
  as,
  className,
  children,
  ...props
}: HeadingProps) {
  const Heading = as || 'p'
  return (
    <Heading className={className} {...props}>
      {children}
    </Heading>
  )
}
